import { Controller } from "@hotwired/stimulus";
import emoticonize from "libs/utils/emoticonize";

export default class extends Controller {
  connect() {
    this.#emoticonize(this.element);
    this.element.addEventListener("keyup", (event) => {
      if (
        event.metaKey ||
        event.ctrlKey ||
        event.code === "MetaLeft" ||
        event.code === "MetaRight"
      )
        return;
      this.#emoticonize(event.target);
    });
  }

  #emoticonize(target) {
    const node = target;
    let text = node.value;
    let position = node.selectionStart - text.length;
    text = emoticonize(text);
    position += text.length;
    node.value = text;
    node.setSelectionRange(position, position);
  }
}
